import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    mainWrapper: {
        display: "flex",
        flexDirection: "column",
        textAlign: "left",
        marginTop: theme.spacing(16),
        fontFamily: "Open Sans",
        backgroundColor: theme.palette.backgrounds.main,
        minHeight: "calc(100vh - 64px)",
    },
    mainSection: {
        display: "flex",
        flexDirection: "column",
        padding: `${theme.spacing(8)} ${theme.spacing(12)}`,
        fontFamily: "Open Sans",
    },
    title: {
        fontSize: "16px",
        fontWeight: 400,
        color: theme.palette.text.primary,
    },
    videoListSectionMainWrapper: {
        display: "flex",
        flexDirection: "column",
        marginTop: theme.spacing(12),
    },
    videoListSectionWrapper: {
        display: "flex",
        flexDirection: "column",
    },
    videoListSectionDivider: {
        marginTop: `${theme.spacing(12)} !important`,
    },
    videoListSectionTitle: {
        fontSize: "14px",
        fontWeight: 600,
        color: theme.palette.text.primary,
    },
    videoListSectionLength: {
        fontSize: "12px",
        fontStyle: "italic",
        textTransform: "lowercase",
        fontWeight: 400,
        color: theme.palette.info.main,
    },
    videoListWrapper: {
        display: "grid",
        gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))",
    },
    videoWrapper: {
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(2),
        marginTop: theme.spacing(4),
    },
    videoTitle: {
        fontSize: "12px",
        fontStyle: "italic",
        fontWeight: 400,
        color: theme.palette.text.primary,
    },
    videoIFrameWrapper: {
        width: theme.spacing(75),
        height: theme.spacing(50),
        overflow: "hidden",
    },
    videoIFrame: {
        border: "none",
        width: "100%",
        height: "100%",
    },
}));
